import { render, staticRenderFns } from "./WiseDynamicForms.vue?vue&type=template&id=964d37e2&scoped=true&"
import script from "./WiseDynamicForms.vue?vue&type=script&lang=js&"
export * from "./WiseDynamicForms.vue?vue&type=script&lang=js&"
import style0 from "./WiseDynamicForms.vue?vue&type=style&index=0&id=964d37e2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "964d37e2",
  null
  
)

export default component.exports